import { ReactNode, ElementType } from "react";
import { twMerge } from "tailwind-merge";

interface OuterContentContainerProps {
  as?: ElementType;
  children: ReactNode;
  className?: string;
  innerClassName?: string;
  id?: string;
}

export function OuterContentContainer({
  as,
  children,
  className,
  innerClassName,
  id,
}: OuterContentContainerProps) {
  const Component = as || "div";

  return (
    <Component
      className={twMerge("flex flex-col items-start w-full md:py-8", className)}
      id={id}
    >
      <div
        className={twMerge(
          "flex flex-col max-w-7xl w-full mx-auto px-4 md:px-8 items-start",
          innerClassName
        )}
      >
        {children}
      </div>
    </Component>
  );
}

export default OuterContentContainer;
